import index from './index.vue';
import { DepartmentForm } from './all.type';

export default index;
export {
    DepartmentForm
};